<template>
  <div class="rightnav new-right-nav">
    <ul>
      <li class="last rightnav-item right-icon-a5" @click="gototop">
        <!-- <a class="rightnav-item-title trans-animate" @click="gototop">
				<i class="icon icon-gotop">&#xe61e;</i>
        </a>-->
        <div class="icon-item rans-animate go-top"></div>
      </li>
      <li class="rightnav-item right-icon-a1">
        <a href="/order/cart/type/1">
          <div class="icon-item cart"></div>
          <span class="cart-num slide-cart-num" v-text="loginInfo.cartCount || 0"></span>
          <!-- <small class="rightnav-cart-num" v-text="loginInfo.cartCount || 0"></small> -->
        </a>
      </li>
      <li class="rightnav-item right-icon-a3">
        <div class="icon-item help"></div>
        <div class="rightnav-sub trans-animate">
          <div class="rightnav-sub-lt">
            <img
              :src="saleData.avatar || '//mobile.nextpcb.com/static/mobile/img/icon/avast.png'"
              alt
            />
          </div>
          <div class="rightnav-sub-gt">
            <p>
              <strong class="f-bold">{{ supportInfo.userName || 'Support Team' }}</strong>
            </p>
            <p>
              <i class="icon icon-email vlm">&#xe627;</i>
              <a
                class="vlm"
                :href="'mailto:' + (supportInfo.email || 'support@nextpcb.com')"
                v-text="supportInfo.email || 'support@nextpcb.com'"
              ></a>
            </p>
            <p>
              <i class="icon vlm f-few icon-tel">&#xe626;</i>
              <a
                class="tel_83643663"
                :href="'tel:' + (supportInfo.mobilePhone || '0086-755-8364 3663')"
                v-text="supportInfo.mobilePhone || '0086-755-83643663'"
              ></a>
            </p>
            <p>
              <i class="icon vlm f-few icon-whatsapp">&#xe61a;</i>
              <a
                :href="'whatsapp://send?phone=' + (saleData.whatsapp || '15013838486')"
                v-text="saleData.whatsapp || '+86 15013838486'"
              ></a>
            </p>
          </div>
        </div>
      </li>
      <li class="rightnav-item">
        <a class="trans-animate mailto_support" href="mailto:support@nextpcb.com">
          <div class="icon-item email"></div>
        </a>
        <div class="rightnav-sub trans-animate">
          <div class="rightnav-sub-gt pd-l-xxl">
            <div v-show="saleData.email" class="pd-b-md">
              <p>{{ LANG.exclusive_sale }}:</p>
              <i class="icon icon-email">&#xe627;</i>
              <a :href="'mailto:' + saleData.email" v-text="saleData.email"></a>
            </div>
            <div>
              <p>{{ LANG.feedback_suggest }}:</p>
              <p>
                <i class="icon icon-email">&#xe627;</i>
                <a href="mailto:support@nextpcb.com" v-text="'support@nextpcb.com'"></a>
              </p>
            </div>
          </div>
        </div>
      </li>
      <li class="rightnav-item right-icon-a2">
        <a class="trans-animate skype_nextpcb" href="skype:nextpcb@outlook.com?add">
          <div class="icon-item sky"></div>
        </a>
      </li>
    </ul>
    <a class="contact-us-new" target="_blank" :href="`${hostName}/contactus`">
      <span>{{ LANG.contact_us }}</span>
      <img :src="$imgList.contact_us" />
    </a>

    <div class="contact-us-mask" v-if="showContact">
      <div class="contact-us-popup">
        <div class="btn-top">
          <span class="right_x" @click="showContact = false"></span>
        </div>
        <iframe
          :src="`${hostName}/zoho/contactus-popup.html`"
          style="border: 0; overflow: hidden"
          width="700px"
          height="758px"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo
    },
    saleData() {
      return this.$store.getters.getLoginInfo.sales || {}
    },
    supportInfo(){
      if([53,126].includes(Number(this.saleData.userId))){
        return {
          userName:'Support Team',
          email:'order@nextpcb.com',
          mobilePhone:'0086-755-83643663'
        }
      }
      else{
        return this.saleData
      }
    }
  },
  data() {
    return {
      showContact: false,
			hostName:'//www.nextpcb.com'
    }
  },
	mounted(){
		this.getEnvHost()
	},
  methods: {
    gototop() {
      this.$tools.scrollAnmiate(document.documentElement, 0)

      // 方法一
      // var nowScroll = window.scrollY
      // var step = nowScroll/100
      // var timoutTimer = setTimeout(() => {
      // 	if(Math.abs(step) <= 1) {
      // 		clearTimeout(timoutTimer)
      // 		return window.scrollTo(0, 0)
      // 	}
      // 	clearTimeout(timoutTimer)
      // 	window.scrollTo(0,nowScroll-step)
      // 	this.gototop()
      // }, 10)
      // 方法二
      // var nowScroll = window.scrollY
      // var intervalTimer = setInterval(() => {
      // 	if(window.scrollY > 0) {
      // 		window.scrollTo(0,window.scrollY-nowScroll/100)
      // 	} else {
      // 		clearInterval(intervalTimer)
      // 	}
      // },10)
      // window.scrollTo(0,0);
    },
		getEnvHost(){
			const current=window.location.host
			if(current.includes('fat')){
				this.hostName='//fat-www.nextpcb.com'
			}
			else if(current.includes('uat')){
				this.hostName='//uat-www.nextpcb.com'
			}
		}
  }
}
</script>
<style lang="scss">
$iconimgurl: "//mobile.nextpcb.com/static/mobile/img/icon";
$itemHeight: 50px;
.rightnav-cart-num {
  position: absolute;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  border-radius: 20px;
  background-color: #fc7021;
  color: #fff;
  text-align: center;
  left: 24px;
  top: 3px;
}
// .right-icon-a1{
// 	background:url(#{$iconimgurl}/right_nav_b1.jpg) no-repeat center center;
// }
// .right-icon-a2{
// 	background:url(#{$iconimgurl}/right_nav_b2.jpg) no-repeat center center;
// }
// .right-icon-a3{
// 	background:url(#{$iconimgurl}/right_nav_b3.jpg) no-repeat center center;
// }
// .right-icon-a4{
// 	background:url(#{$iconimgurl}/right_nav_b4.jpg) no-repeat center center;
// }
// .right-icon-a5{
// 	background:url(#{$iconimgurl}/right_nav_b5.jpg) no-repeat center center;
// }
// .right-icon-a1:hover{
// 	background:url(#{$iconimgurl}/right_nav_a1.jpg) no-repeat center center;
// }
// .right-icon-a2:hover{
// 	background:url(#{$iconimgurl}/right_nav_a2.jpg) no-repeat center center;
// }
// .right-icon-a3:hover{
// 	background:url(#{$iconimgurl}/right_nav_a3.jpg) no-repeat center center;
// }
// .right-icon-a4:hover{
// 	background:url(#{$iconimgurl}/right_nav_a4.jpg) no-repeat center center;
// }
// .right-icon-a5:hover{
// 	background:url(#{$iconimgurl}/right_nav_a5.jpg) no-repeat center center;
// }

.rightnav {
  // position: fixed;
  // z-index: 999;
  // right: 25px;
  // bottom: 100px;
  // // box-shadow: 0 0 10px #ccc;
  // background-color: #fff;
  // // width: 50px;
  &-item {
    position: relative;
    background-size: contain;
    &::after {
      content: "";
      position: absolute;
      left: 10px;
      right: 10px;
      // border-bottom: 1px solid #ededed;
    }
    &:hover {
      .rightnav-sub {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }
  .last::after {
    display: none;
  }
  a {
    display: block;
    height: $itemHeight;
    line-height: $itemHeight;
    text-align: center;
    cursor: pointer;
    i.icon {
      font-size: 24px;
      color: #666;
    }
    i.icon-gotop {
      font-size: 28px;
    }
  }
  a.rightnav-item-title {
    &:hover {
      background-color: #cc0000;
      i.icon {
        color: #fff;
      }
    }
  }
  //-sub
  &-sub {
    position: absolute;
    top: 0;
    right: $itemHeight;
    box-shadow: 0 0 10px #ccc;
    right: 50px;
    background-color: #fff;
    opacity: 0;
    overflow: hidden;
    min-width: 300px;
    transform: translateY(300px);
    z-index: 10002;
    i.icon {
      display: inline-block;
      vertical-align: middle;
      width: 18px;
      height: 22px;
      line-height: 22px;
      background-size: cover;
      margin-right: 12px;
    }
    // i.icon.icon-email{
    // 	background-position-y: 2px;
    // }
    // i.icon.icon-tel{
    // 	background-position-y: -29px;
    // }
    // i.icon.icon-whatsapp{
    // 	background-position-y: -57px;
    // }
    &-lt {
      float: left;
      padding: 12px 20px;
      img {
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }
    }
    &-gt {
      overflow: hidden;
      display: block;
      padding: 10px 0 8px;
    }
    li {
      white-space: nowrap;
      padding-right: 50px;
    }
    a {
      display: inline-block;
      vertical-align: middle;
      height: 30px;
      line-height: 30px;
    }
  }
}

.contact-us-mask {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 29999;
  background: rgba($color: #000000, $alpha: 0.5);

  .contact-us-popup {
    width: 700px;
    height: 800px;
    background: #fff;
    border-radius: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .btn-top {
      height: 42px;
      line-height: 42px;

      .right_x {
        // 宽高改这里就行了
        $width: 13px;
        // 通过计算得出的宽高比例
        $height: calc($width / 7);

        position: absolute;
        top: 16px;
        right: 16px;

        width: $width;
        height: $width;
        cursor: pointer;
        // background: #000;
        line-height: 0;
        font-size: 0;
        &::after,
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: $width;
          height: $height;
          background: #333;
          transform: rotate(-45deg);
        }
        &::before {
          transform: rotate(45deg);
        }

        &:hover {
          &::after,
          &::before {
            background: #666;
          }
        }
      }
    }
  }
}
</style>
